import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useState } from "react";
import usePersist from "./usePersist";
import useUnmountedRef from "./useUnmountedRef";
function useSafeState(initialState) {
  var unmountedRef = useUnmountedRef();
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setSafeState = usePersist(function (newState) {
    if (unmountedRef.current) {
      return;
    }
    setState(newState);
  });
  return [state, setSafeState];
}
export default useSafeState;